var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var viewMaxToPixel = function (value, options) {
    return value * Math.max(options.viewWidthPixelValue(), options.viewHeightPixelValue()) * 100;
};
var viewMaxToCentimeter = function (value, options) {
    return pixel.cm(viewMaxToPixel(value, options));
};
var viewMaxToMillimeter = function (value, options) {
    return pixel.mm(viewMaxToPixel(value, options));
};
var viewMaxToQuarter = function (value, options) {
    return pixel.Q(viewMaxToPixel(value, options));
};
var viewMaxToInch = function (value, options) {
    return pixel.in(viewMaxToPixel(value, options));
};
var viewMaxToPica = function (value, options) {
    return pixel.pc(viewMaxToPixel(value, options));
};
var viewMaxToPoint = function (value, options) {
    return pixel.pt(viewMaxToPixel(value, options));
};
var viewMaxToREM = function (value, options) {
    return pixel.rem(viewMaxToPixel(value, options), options);
};
var viewMaxToEM = function (value, options) {
    return pixel.em(viewMaxToPixel(value, options), options);
};
var viewMaxToViewWidth = function (value, options) {
    return pixel.vw(viewMaxToPixel(value, options), options);
};
var viewMaxToViewHeight = function (value, options) {
    return pixel.vh(viewMaxToPixel(value, options), options);
};
var viewMaxToViewMin = function (value, options) {
    return pixel.vmin(viewMaxToPixel(value, options), options);
};
export var viewMax = (_a = {},
    _a[UnitSuffix.Pixel] = viewMaxToPixel,
    _a[UnitSuffix.Centimeter] = viewMaxToCentimeter,
    _a[UnitSuffix.Millimeter] = viewMaxToMillimeter,
    _a[UnitSuffix.Quarter] = viewMaxToQuarter,
    _a[UnitSuffix.Inch] = viewMaxToInch,
    _a[UnitSuffix.Pica] = viewMaxToPica,
    _a[UnitSuffix.Point] = viewMaxToPoint,
    _a[UnitSuffix.REM] = viewMaxToREM,
    _a[UnitSuffix.EM] = viewMaxToEM,
    _a[UnitSuffix.ViewWidth] = viewMaxToViewWidth,
    _a[UnitSuffix.ViewHeight] = viewMaxToViewHeight,
    _a[UnitSuffix.ViewMin] = viewMaxToViewMin,
    _a[UnitSuffix.ViewMax] = noConvert,
    _a);
//# sourceMappingURL=view-max.js.map